import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdSave } from "react-icons/md";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader, ScrollToTop } from "../../../components";

const UbahUser = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [tipeUser, setTipeUser] = useState("DEVELOPER");
  const [aksesKategori, setAksesKategori] = useState(false);
  const [aksesDaftarUser, setAksesDaftarUser] = useState(false);
  const [aksesMerk, setAksesMerk] = useState(false);
  const [aksesBarang, setAksesBarang] = useState(false);
  const [aksesAdminWhatsapp, setAksesAdminWhatsapp] = useState(false);
  const [aksesInformasiToko, setAksesInformasiToko] = useState(false);
  const [aksesKeranjang, setAksesKeranjang] = useState(false);
  const [aksesPesanan, setAksesPesanan] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadUser = async () => {
      setLoading(true);
      try {
        const response = await axios.post(`${tempUrl}/findUser/${id}`, {
          _id: user.id,
          token: user.token,
        });
        setUsername(response.data.username || "");
        setTipeUser(response.data.tipeUser || "DEVELOPER");
        setAksesKategori(Boolean(response.data.akses?.kategori));
        setAksesDaftarUser(Boolean(response.data.akses?.daftarUser));
        setAksesMerk(Boolean(response.data.akses?.merk));
        setAksesBarang(Boolean(response.data.akses?.barang));
        setAksesAdminWhatsapp(Boolean(response.data.akses?.adminWhatsapp));
        setAksesInformasiToko(Boolean(response.data.akses?.informasiToko));
        setAksesKeranjang(Boolean(response.data.akses?.keranjang));
        setAksesPesanan(Boolean(response.data.akses?.pesanan));
      } catch (err) {
        if (err.response?.status === 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        }
        setError(err.response?.data?.message || "Gagal mengambil data user.");
      }
      setLoading(false);
    };
    loadUser();
  }, [dispatch, id, navigate, user.id, user.token]);

  const updateUser = async (event) => {
    event.preventDefault();
    if (!username.trim()) {
      setError("Username wajib diisi.");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        username,
        tipeUser,
        akses: {
          kategori: aksesKategori,
          daftarUser: aksesDaftarUser,
          merk: aksesMerk,
          barang: aksesBarang,
          adminWhatsapp: aksesAdminWhatsapp,
          informasiToko: aksesInformasiToko,
          keranjang: aksesKeranjang,
          pesanan: aksesPesanan,
        },
        _id: user.id,
        token: user.token,
      };
      if (password) payload.password = password;

      await axios.post(`${tempUrl}/users/${id}`, payload);
      if (String(user.id) === String(id)) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      } else {
        navigate("/daftarUser");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Gagal mengubah user.");
    }
    setLoading(false);
  };

  if (loading) return <Loader />;

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">User</div>
          <h1 className="page-title">Ubah User</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        <Form onSubmit={updateUser}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Username</Form.Label>
                <Form.Control value={username} onChange={(e) => setUsername(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Password Baru</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  placeholder="Kosongkan jika tidak ingin mengganti"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Tipe User</Form.Label>
                <Form.Select
                  value={tipeUser}
                  onChange={(e) => setTipeUser(e.target.value)}
                >
                  <option value="DEVELOPER">DEVELOPER</option>
                  <option value="MANAGER">MANAGER</option>
                  <option value="ADMIN">ADMIN</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <h2 className="h6 fw-bold mt-4 mb-2">Hak Akses</h2>
          <div className="access-menu-groups">
            <div className="access-menu-group">
              <div className="access-menu-title">Master</div>
              <Form.Check
                type="checkbox"
                label="Kategori"
                checked={aksesKategori}
                onChange={() => setAksesKategori(!aksesKategori)}
              />
              <Form.Check
                type="checkbox"
                label="Merk"
                checked={aksesMerk}
                onChange={() => setAksesMerk(!aksesMerk)}
              />
              <Form.Check
                type="checkbox"
                label="Barang"
                checked={aksesBarang}
                onChange={() => setAksesBarang(!aksesBarang)}
              />
              <Form.Check
                type="checkbox"
                label="WA Admin"
                checked={aksesAdminWhatsapp}
                onChange={() => setAksesAdminWhatsapp(!aksesAdminWhatsapp)}
              />
              <Form.Check
                type="checkbox"
                label="Informasi Toko"
                checked={aksesInformasiToko}
                onChange={() => setAksesInformasiToko(!aksesInformasiToko)}
              />
            </div>
            <div className="access-menu-group">
              <div className="access-menu-title">Transaksi</div>
              <Form.Check
                type="checkbox"
                label="Keranjang"
                checked={aksesKeranjang}
                onChange={() => setAksesKeranjang(!aksesKeranjang)}
              />
              <Form.Check
                type="checkbox"
                label="Pesanan"
                checked={aksesPesanan}
                onChange={() => setAksesPesanan(!aksesPesanan)}
              />
            </div>
            <div className="access-menu-group">
              <div className="access-menu-title">Utility</div>
              <Form.Check
                type="checkbox"
                label="Daftar User"
                checked={aksesDaftarUser}
                onChange={() => setAksesDaftarUser(!aksesDaftarUser)}
              />
            </div>
          </div>
          <div className="form-actions mt-3">
            <Button className="btn-back" variant="outline-secondary" type="button" onClick={() => navigate(`/daftarUser/${id}`)}>
              {"< Kembali"}
            </Button>
            <Button className="btn-icon" type="submit">
              <MdSave /> Simpan
            </Button>
          </div>
        </Form>
      </section>
    </div>
  );
};

export default UbahUser;
